import React, { Component } from "react";

import {  Modal, ModalBody,  } from "reactstrap";



import Loadingsvg from "../assets/Loading.svg";

class LoadingModel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.OpenModel}
          backdrop="static"
          centered
          size="sm"
          style={{ height: "80px", width: "80px", padding: "0px" }}
        >
          <ModalBody className="text-center m-0 p-0">
            <img src={Loadingsvg} alt="" height="75" width="75" />
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}


export default LoadingModel;
